import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import { useTranslation } from 'react-i18next';

// ui
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import MaterialTable, { MTableToolbar } from 'material-table';
import Tooltip from '@material-ui/core/Tooltip';
import { faChartLine, faVideo } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@material-ui/core/IconButton';

// components
// import DamLightbox from '../../DamLightbox';
import DamModal from '../../../../components/modal/Modal';
import DamChartDailyMain from '../../chart/daily/DamChartDailyMain';
// import DamChartDailyCompareMain from '../../chart/compare/DamChartDailyCompareMain';

// Utils
import formatNumber from '../../../../utils/number/Number';
import exportCsv from '../../../../utils/export/Csv';

// style
import { StyledIconButton } from '../../../../components/button/Button';
import styles from '../style';
import tableIcons from '../../../../components/table/MaterialTableIcon';
import DamLargeColor from '../../../../components/color/dam/DamLargeColor';
import damStatusColor from '../../../../components/color/dam/DamStatusColor';

const useStyles = makeStyles(styles);

export default function DamLatestLarge(props) {
  const damIdNoTransaction = [231, 319, 320];
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, handleSearchMarker, currentMode, currentArea, userIsLogin,
  } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  const [selectSituationLevel, setSituationLevel] = useState('');
  const [damData, setDamData] = useState([]);
  const [modalData, setModalData] = useState({
    open: false,
    header: t('กราฟอ่างเก็บน้ำรายวัน กรมชลประทาน'),
    subheader: null,
    content: null,
    style: null,
  });

  useEffect(() => {
    setDamData(datas);
  }, [datas]);

  function filterData(currentData, mode, area) {
    let filterD = [];

    if (mode === 'province' && area.code !== '0') {
      filterD = currentData.filter((d) => d.geocode.province_code === area.code);
    } else if (currentMode === 'basin' && area.code !== '0') {
      filterD = currentData.filter((d) => d.basin.basin_code === parseInt(area.code, 10));
    } else {
      filterD = currentData;
    }

    return filterD;
  }

  const handleChart = (data) => (e) => {
    e.preventDefault();

    setModalData({
      open: true,
      header: t('กราฟอ่างเก็บน้ำรายวัน กรมชลประทาน'),
      subheader: null,
      content: <DamChartDailyMain id={data} agencyId={12} />,
    });
  };

  const handleSituationChange = (event) => {
    const selectVar = event.target.value;
    const dataFilter = (selectVar === '') ? datas : datas.filter((d) => DamLargeColor(d.dam_storage_percent).color.statusColor === selectVar);

    setSituationLevel(selectVar);
    setDamData(dataFilter);
  };

  // const handleChartCompareDaily = (data) => (e) => {
  //   e.preventDefault();

  //   setModalData({
  //     open: true,
  //     header: 'กราฟเปรียบเทียบอ่างเก็บน้ำรายวัน กรมชลประทาน',
  //     subheader: null,
  //     content: <DamChartDailyCompareMain id={data} agencyId={12} />,
  //   });
  // };

  return (
    <>
      <Paper className={classes.root}>
        <MaterialTable
          icons={tableIcons}
          columns={[
            {
              title: t('อ่างเก็บน้ำ'),
              title_export: t('อ่างเก็บน้ำ'),
              field: 'dam.dam_name.th',
              width: 190,
              headerStyle: {
                left: 0,
                position: 'sticky',
                zIndex: 50,
              },
              cellStyle: {
                // borderBottom: '1px solid rgba(224, 224, 224, 1)',
                left: 0,
                position: 'sticky',
                // zIndex: 40,
                wordWrap: 'normal',
                padding: '0em',
                // backgroundColor: 'white',
              },
              render: (rowData) => {
                // cctv
                if (rowData.cctv.url) {
                  return (
                    <Box display="flex" style={{ backgroundColor: 'white' }}>
                      <Button
                        onClick={handleSearchMarker(
                          rowData.id + rowData.geocode.id,
                          rowData.dam.dam_lat,
                          rowData.dam.dam_long,
                        )}
                        title={rowData.agency.agency_name.th}
                        data-cy={rowData.dam.dam_name.th}
                      >
                        {`${t('เขื่อน')}${rowData.dam.dam_name.th}`}
                      </Button>
                      <span style={{ marginTop: 0 }}>
                        <Tooltip title="CCTV">
                          <IconButton aria-label="CCTV" onClick={() => { window.open(`${rowData.cctv.url}`, '_blank'); }}>
                            <FontAwesomeIcon icon={faVideo} size="xs" />
                          </IconButton>
                        </Tooltip>
                        {/* <DamLightbox
                          imgs={[{ url: rowData.cctv.url, title: `${t('เขื่อน')}${rowData.dam.dam_name.th}` }]}
                          idx={0}
                          title="title"
                        /> */}
                      </span>
                    </Box>
                  );
                }

                return (
                  <Box display="flex" style={{ backgroundColor: 'white' }}>
                    <Button
                      onClick={handleSearchMarker(
                        rowData.id + rowData.geocode.id,
                        rowData.dam.dam_lat,
                        rowData.dam.dam_long,
                      )}
                      title={t('แสดงตำแหน่งบนแผนที่')}
                      data-cy={rowData.dam.dam_name.th}
                    >
                      {`${t('เขื่อน')}${rowData.dam.dam_name.th}`}
                    </Button>
                  </Box>
                );
              },
              customSort: (a, b) => a.dam.dam_name.th.localeCompare(b.dam.dam_name.th, 'th'),
            },
            {
              title: t('จังหวัด'),
              title_export: t('จังหวัด'),
              field: 'geocode.province_name.th',
              width: 140,
            },
            {
              title: t('ลุ่มน้ำ'),
              title_export: t('ลุ่มน้ำ'),
              field: 'basin.basin_name.th',
              width: 150,
              hidden: !userIsLogin,
            },
            //           {
            //             title:
            // <>
            //   {t('ความจุ')}
            //   <br />
            //   <Typography variant="caption" display="block">{t('ล้าน ลบ.ม.')}</Typography>
            // </>,
            //             title_export: t('ความจุ (ล้าน ลบ.ม.)'),
            //             field: 'dam.max_storage',
            //             type: 'numeric',
            //             width: 115,
            //             render: (rowData) => `${formatNumber(rowData.dam.max_storage)}`,
            //             // customSort: (a, b) => a.dam_storage - b.dam_storage,
            //           },
            {
              title:
  <>
    {t('ความจุที่ รนก.')}
    <br />
    <Typography variant="caption" display="block">{t(' ล้าน ลบ.ม.')}</Typography>
  </>,
              title_export: t('ความจุที่ รนก. ( ล้าน ลบ.ม.)'),
              field: 'dam.normal_storage',
              type: 'numeric',
              width: 115,
              render: (rowData) => `${formatNumber(rowData.dam.normal_storage)}`,
            },
            {
              title:
  <>
    {t('ความจุน้ำใช้การ')}
    <br />
    <Typography variant="caption" display="block">{t(' ล้าน ลบ.ม.')}</Typography>
  </>,
              title_export: t('ความจุน้ำใช้การ ( ล้าน ลบ.ม.)'),
              field: 'dam.uses_water',
              type: 'numeric',
              width: 115,
              render: (rowData) => `${formatNumber(rowData.dam.uses_water)}`,
            },
            {
              title:
  <>
    {t('ปริมาตรน้ำ')}
    <br />
    <Typography variant="caption" display="block">
      {t(' ล้าน ลบ.ม.')}
      <br />
      {' '}
      {t('(% ความจุที่ รนก.)')}
    </Typography>
  </>,
              title_export: `${t('ปริมาตรน้ำ')} ${(' ล้าน ลบ.ม.')}\n${t('(% ความจุที่ รนก.)')}`,
              field: 'dam_storage',
              type: 'numeric',
              width: 130,
              render: (rowData) => {
                const status = DamLargeColor(rowData.dam_storage_percent);

                if (damIdNoTransaction.includes(rowData.dam.id)) {
                  return (
                    '-'
                  );
                }

                return (
                  <span>
                    {formatNumber(rowData.dam_storage)}
                    {' '}
                    <span style={{ color: status.color.statusColor }}>
                      (
                      {rowData.dam_storage_percent.toFixed(0)}
                      %)
                    </span>
                  </span>
                );
              },
            },
            {
              title: t('%ความจุ'),
              title_export: t(' %ความจุ'),
              field: 'dam_storage_percent',
              type: 'numeric',
              hidden: true,
            },
            {
              title: t('ปริมาตรใช้การ'),
              title_export: t('ปริมาตรใช้การ (ล้าน ลบ.ม.)'),
              field: 'dam_uses_water',
              type: 'numeric',
              hidden: true,
            },
            {
              title:
  <>
    {t('ปริมาตรน้ำใช้การ')}
    <br />
    <Typography variant="caption" display="block">
      {t(' ล้าน ลบ.ม.')}
      <br />
      {' '}
      {t('(% ความจุน้ำใช้การ)')}
    </Typography>
  </>,
              title_export: `${t('ปริมาตรน้ำใช้การ')} ${t(' ล้าน ลบ.ม.')}\n${t('(% ความจุน้ำใช้การ)')}`,
              field: 'dam_uses_water_percent',
              type: 'numeric',
              width: 140,
              render: (rowData) => `${formatNumber(rowData.dam_uses_water)} (${rowData.dam_uses_water_percent.toFixed(0)}%)`,
              // วิธีการคำนวณ - (ปริมาตรน้ำใช้การ*100)/ความจุใช้การ
              // render: (rowData) => {
              //   let displayText = '';

              //   if (damIdNoTransaction.includes(rowData.dam.id)) {
              //     displayText = '-';
              //   } else {
              //     displayText = `${formatNumber(rowData.dam_uses_water)} (${rowData.dam_uses_water_percent_calc.toFixed(0)}%)`;
              //   }

              //   return displayText;
              // },
            },
            {
              title:
  <>
    {t('น้ำไหลลง')}
    <br />
    <Typography variant="caption" display="block">{t(' ล้าน ลบ.ม.')}</Typography>
  </>,
              title_export: t('น้ำไหลลง ( ล้าน ลบ.ม.)'),
              field: 'dam_inflow',
              type: 'numeric',
              width: 125,
              render: (rowData) => {
                let displayText = '';

                if (damIdNoTransaction.includes(rowData.dam.id)) {
                  displayText = '-';
                } else {
                  displayText = rowData.dam_inflow;
                }

                return displayText;
              },
            },
            {
              title:
  <>
    {t('น้ำระบาย')}
    <br />
    <Typography variant="caption" display="block">{t(' ล้าน ลบ.ม.')}</Typography>
  </>,
              title_export: t('น้ำระบาย ( ล้าน ลบ.ม.)'),
              field: 'dam_released',
              type: 'numeric',
              width: 115,
              render: (rowData) => {
                let displayText = '';

                if (damIdNoTransaction.includes(rowData.dam.id)) {
                  displayText = '-';
                } else {
                  displayText = rowData.dam_released;
                }

                return displayText;
              },
            },
            {
              title: '',
              field: '',
              sorting: false,
              width: 115,
              align: 'center',
              render: (rowData) => {
                if (damIdNoTransaction.includes(rowData.dam.id)) {
                  return '';
                }

                return (
                  <>
                    <Tooltip title={t('กราฟรายปี')}>
                      <StyledIconButton onClick={handleChart(rowData.dam.id)}>
                        <FontAwesomeIcon icon={faChartLine} style={{ color: '#888' }} />
                      </StyledIconButton>
                    </Tooltip>
                    {/* <Tooltip title="กราฟเปรียบเทียบรายวัน">
                      <StyledIconButton onClick={handleChartCompareDaily(rowData.dam.id)}>
                        <FontAwesomeIcon icon={faChartBar} style={{ color: '#888' }} />
                      </StyledIconButton>
                    </Tooltip> */}
                  </>
                );
              },
            },
          ]}
          data={filterData(damData, currentMode, currentArea)}
          localization={{
            toolbar: {
              searchPlaceholder: t('ค้นหา'),
              exportTitle: t('ดาวน์โหลดข้อมูล แหล่งน้ำขนาดใหญ่'),
            },
            pagination: {
              labelRowsSelect: t('แถว'),
            },
            body: { emptyDataSourceMessage: damData.length === 0 && selectSituationLevel === '' ? <h3>{t('กำลังโหลดข้อมูล...')}</h3> : <h3>{t('ไม่มีข้อมูลแหล่งน้ำขนาดใหญ่ ตามเงื่อนไข')}</h3> },
          }}
          options={{
            // tableLayout: 'fixed',
            pageSize: 10,
            sorting: true,
            // https://stackoverflow.com/questions/61048405/material-ui-how-to-make-the-search-textfield-expandable-in-material-table
            searchFieldStyle: {
              width: '50%',
              alignSelf: 'flex-end',
            },
            rowStyle: {
              wordWrap: 'break-word',
            },
            toolbar: true,
            showTitle: false,
            // search: true,
            exportButton: isExport,
            exportCsv,
            cellStyle: {
              padding: 8,
            },
          }}
          components={{
            Toolbar: (props) => (
              <Grid container direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
                <Grid item xs={12} sm={8} md={6}>
                  <MTableToolbar {...props} />
                </Grid>
                <Grid item xs="auto" sm="auto" md="auto">
                  <FormControl className={classes.formControl}>
                    <NativeSelect
                      id="status"
                      value={selectSituationLevel}
                      onChange={handleSituationChange}
                    >
                      <option value="">{t('แสดงทุกปริมาณน้ำ')}</option>
                      {damStatusColor.slice(1).map((val) => (
                        <option key={uniqueId()} value={val.statusColor}>
                          {`${val.label} (${val.rangeTitle}%)`}
                        </option>
                      ))}
                    </NativeSelect>
                  </FormControl>
                </Grid>
              </Grid>
            ),
          }}
        />

        <DamModal
          open={modalData.open}
          modalHeader={modalData.header}
          modalSubHeader={modalData.subheader}
          modalContent={modalData.content}
          modalStyle={modalData.style}
        />
      </Paper>
    </>
  );
}

DamLatestLarge.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  handleSearchMarker: PropTypes.func.isRequired,
  currentMode: PropTypes.string.isRequired,
  currentArea: PropTypes.instanceOf(Object).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
